export enum EventType {
  GENERATE_BILLET = 'generate_billet',
  FORGOT_PASSWORD = 'forgot_password',
  READ_BILLET = 'read_billet',
  CREATE_PIX_KEY = 'create_pix_key',
  DELETE_PIX_KEY = 'delete_pix_key',
  SHARE_PAY_STUB = 'share_pay_stub',
  GENERATE_PIX_QR_CODE = 'generate_pix_qr_code',
  READ_PIX_QR_CODE = 'read_pix_qr_code',
  SHARE_PIX_QR_CODE = 'share_pix_qr_code',
  CREATE_CONTACT = 'create_contact',
  CHANGE_PASSWORD = 'change_password',
  CHANGE_PIN = 'change_pin',
  CHANGE_PROFILE_PHOTO = 'change_profile_photo',
  MAKE_TRANSACTION = 'make_transaction',
  SHARE_RECEIPT = 'share_receipt',
  LOGIN = 'login',
  SIGN_UP_START = 'sign_up_start',
  SIGN_UP = 'sign_up',
  LOGOUT = 'logout',
  HOME_TAB_CARDS_BUTTON = 'home_tab_cards_button',
  HOME_TAB_EXTRACT_BUTTON = 'home_tab_extract_button',
  HOME_TAB_NOTIFICATION_BUTTON = 'home_tab_notification_button',
  HOME_TAB_PROFILE_BUTTON = 'home_tab_profile_button',
  HOME_PIX_BUTTON = 'home_pix_button',
  HOME_BUTTON = 'home_button',
  HOME_CHARGE_BUTTON = 'home_charge_button',
  HOME_CASHBACK_BUTTON = 'home_cashback_button',
  HOME_ESCROW_BUTTON = 'home_escrow_button',
  HOME_GAIN_BUTTON = 'home_gain_button',
  HOME_LOAN_BUTTON = 'home_loan_button',
  HOME_PAYMENT_BUTTON = 'home_payment_button',
  HOME_RECEIVABLE_BUTTON = 'home_receivable_button',
  HOME_TRANSFER_BUTTON = 'home_transfer_button',
  HOME_FILES_BUTTON = 'home_files_button',
  HOME_PAYABLE_BUTTON = 'home_payable_button',
  HOME_INVESTMENTS_BUTTON = 'home_investments_button',
  PIX_CREATE_KEY_BUTTON = 'pix_create_key_button',
  PIX_PAY_BUTTON = 'pix_pay_button',
  PIX_REQUEST_BUTTON = 'pix_request_button',
  PIX_LIMITS_BUTTON = 'pix_limits_button',
  BOTTOM_MODAL_TRANSFER_PIX = 'bottom_modal_transfer_pix',
  BOTTOM_MODAL_TRANSFER_P2P = 'bottom_modal_transfer_p2p',
  BOTTOM_MODAL_TRANSFER_QR_CODE = 'bottom_modal_transfer_qr_code',
  BOTTOM_MODAL_TRANSFER_TED = 'bottom_modal_transfer_ted',
  BOTTOM_MODAL_RECHARGE_BILLET = 'bottom_modal_recharge_billet',
  BOTTOM_MODAL_RECHARGE_ATM = 'bottom_modal_recharge_atm',
  BOTTOM_MODAL_RECHARGE_PIX = 'bottom_modal_recharge_pix',
  BOTTOM_MODAL_CASHBACK = 'bottom_modal_cashback',
  BOTTOM_MODAL_CARD = 'bottom_modal_card',
  BOTTOM_MODAL_LOAN = 'bottom_modal_loan',
  BOTTOM_MODAL_RECHARGE_QR_CODE = 'bottom_modal_recharge_qr_code',
  BOTTOM_MODAL_PAY_BILLET = 'bottom_modal_pay_billet',
  BOTTOM_MODAL_PAY_QR_CODE = 'bottom_modal_pay_qr_code',
  BOTTOM_MODAL_ATM_WITHDRAW = 'bottom_modal_atm_withdraw',
  BOTTOM_MODAL_ATM_DEPOSIT = 'bottom_modal_atm_deposit',
  BOTTOM_MODAL_SERVICES_RECHARGE = 'bottom_modal_services_recharge',
  BOTTOM_MODAL_SERVICES_LENDING = 'bottom_modal_services_lending',
  BOTTOM_MODAL_SERVICES_BIRTHDAY = 'bottom_modal_services_birthday',
  FAQ_ACCESS = 'faq_access',
  BUTTON_RECEIVABLE_MANUAL = 'button_receivable_manual',
  BUTTON_RECEIVABLE_PAYMENT_LINK = 'button_receivable_payment_link',
  RECEIVABLE_GENERATE_PAYMENT_LINK = 'receivable_generate_payment_link',
  RECEIVABLE_SHARE_PAYMENT_LINK = 'receivable_share_payment_link',
  RECEIVABLE_FILE_ADDED = 'receivable_file_added',
  PAYABLE_FILE_ADDED = 'payable_file_added',
  PAYABLE_APPROVE_GROUP = 'payable_approve_group',
  PAYABLE_REPROVE_GROUP = 'payable_reprove_group',
  CHANGE_CNAB_VOTE_LIMIT = 'change_cnab_vote_limit',
  INVESTMENT_TRANSFER_BUTTON = 'investment_transfer_button',
  INVESTMENT_PRODUCTS_AVAILABLE_BUTTON = 'investment_products_available_button',
  INVESTMENT_POSITION_BUTTON = 'investment_position_button',
  HOME_PAYSLIP_BUTTON = 'home_payslip_button',
}

export enum PageClass {
  AUTH = 'auth',
  HOME = 'home',
  SIDEBAR = 'sidebar',
  CARDS = 'cards',
  ESCROW = 'escrow',
  EXTRACT = 'extract',
  MY_ACCOUNT = 'my-account',
  NOT_FOUND = 'not-found',
  PAYMENT = 'payment',
  ONBOARDING = 'onboarding',
  PIX = 'pix',
  TRANSFER = 'transfer',
  INVESTMENTS = 'investments',
  TRADING_NOTES = 'trading-notes',
  MANAGER_USER = 'manager-user',
  EMPLOYEES = 'employees',
  CONDOMINIUMS = 'condominiums',
  PAYSLIP = 'payslip',
  RECHARGE = 'recharge-cellphone',
}
